module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/tides/tide-list/tide-list.component.sass
// module id = ./src/app/tides/tide-list/tide-list.component.sass
// module chunks = main